<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import strperftablolardetayparametre from "@/models/strperftablolardetayparametre";
export default {
  mixins: [Api, Sabit, strperftablolardetayparametre],
  props: ["Id"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,

  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
       
          this.Update("StrPerfTablolarDetayParametre", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrPerfTablolarDetayParametre
              this.$emit("TableUpdate");
              this.$bvModal.hide("IndexModalEdit");
            }
          });

      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="IndexModalEdit"
      size="lg"
      title="Düzenle"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">  
        <forminput
          :FormDataType="FormDataType.Sirano"
          :Value="FormData.Sirano"
          :v="$v.FormData.Sirano"
          @input="FormData.Sirano = $event"
        />

        <button class="btn btn-primary" type="submit">
          {{ $t("StrPerfTablolarDetayParametre.IndexModalEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
